import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { DashboardPanel } from '../models/panel';

@Injectable({
  providedIn: 'root',
})
export class DashboardServicesService {
  url = environment.apiUrl;

  constructor(private http: HttpClient) {
   
  }

  getDashboard(
    idUsuario: number | null,
    clientNumber: number
  ): Observable<DashboardPanel[]> {
    var params = '?clientNumber=' + clientNumber;
    if (idUsuario != null) {
      params += '&userId=' + idUsuario;
    }
    return this.http.get<DashboardPanel[]>(this.url + 'Dashboard' + params);
  }

  saveDashboard(
    clientNumber: number,
    idUsuario: number | null,
    newDashboard: DashboardPanel[]
  ): Observable<DashboardPanel[]> {
    return this.http.post<DashboardPanel[]>(
      this.url + 'Dashboard',
      {
        clientNumber: clientNumber.toString(),
        userId: idUsuario == null ? null : idUsuario.toString(),
        responseDashboard: newDashboard,
      }
    );
  }

  infoPanel(
    endpointPanel: string,
    clientNumber: number
  ): Observable<DashboardPanel> {
    var newEndpoint = endpointPanel.replace("'x'", clientNumber.toString());
    return this.http.get<DashboardPanel>(
      this.url + 'Dashboard/' + newEndpoint  
    );
  }

  setEditable(edit: string) {
    localStorage.setItem('editable', edit);
  }
  getEditable() {
    return localStorage.getItem('editable') == 'true' ? true : false;
  }
}
